import * as z from "zod";
import { gql } from "graphql-request";
import { Sys, SysFragment } from "../sys";
import { Image, ImageFragment } from "../image";

export const PollTargetsBase = z.object({
  pollTitle: z.string().nullable(),
  pollDescription: z.string().nullable(),
});

export const PollTargets = z.object({
  id: z.string(),
  value: z.number(),
  name: z.string(),
  imageURL: z.string(),
  maxBan: z.number().optional(),
});

export const PollTargetsArray = z.array(PollTargets).nullable();

export const CarouselEventPollTargetsEntry = PollTargetsBase.extend({
  __typename: z.literal("CarouselEventPollTargetsEntry"),
  sys: Sys,
  entryTitle: z.string().nullable(),
  entryHideTitle: z.boolean().nullable(),
  carouselImage: Image.nullable(),
  carouselImageEn: Image.nullable(),
  pollTargets: PollTargetsArray,
});

export type CarouselEventPollTargetsEntry = z.infer<
  typeof CarouselEventPollTargetsEntry
>;

export const CarouselEventPollTargetsEntryFragment = gql`
  fragment CarouselEventPollTargetsEntryFragment on CarouselEventPollTargetsEntry {
    __typename
    sys {
      ...SysFragment
    }

    entryTitle
    entryHideTitle
    pollTitle
    pollDescription
    carouselImage {
      ...ImageFragment
    }
    carouselImageEn: carouselImage(locale: "en") {
      ...ImageFragment
    }

    pollTargets
  }

  ${SysFragment}
  ${ImageFragment}
`;
